module.exports = require('./gameBridge.js').default;